import { request } from './api';

export interface MeUserInfo {
    user_id?: string;
    userId?: string;
    username?: string;
    nickname?: string;
    avatar?: string;
    email?: string;
    mobile?: string | null;
}

// 获取当前登录用户信息（IAM 接口：GET /flagos/api/v1/auth/iam/me）
export const getUserInfo = (isJumpLogin = true, isShowErrorTip = false): Promise<MeUserInfo | undefined> => {
    return request(
        {
            method: 'get',
            url: '/auth/iam/me',
        },
        isShowErrorTip,
        isJumpLogin
    ).then(res => {
        const info = res?.data?.userResponse ?? res?.data;
        if (!info) return info;
        return {
            ...info,
            userId: info.userId ?? info.user_id,
            mobile: info.mobile ?? undefined,
        };
    });
};
